import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { Colors, Typography, Img } from '../../../index';
import { Heading, HeadingLevel } from '../../display/Heading';
import { AsanaIcon, AsanaIconMobile, DefaultCompanies, DropboxIcon, DropboxIconMobile, MetaIcon, MetaIconMobile, ShopifyIcon, ShopifyIconMobile, SlackIcon, SlackIconMobile, } from './logoIcons';
import { Fragment } from 'react';
const breakpoints = {
    tablet: 768,
    desktop: 1230,
};
const sanitizeClassName = (size) => {
    return `${size}`.replace(/[^a-z0-9]/gi, '-');
};
const Styles = labelStyles('LogoBar', {
    root: css `
    display: grid;
    justify-content: center;
    justify-items: center;
    grid-gap: 30px;
  `,
    title: css `
    ${Typography.smallPrint1};
    color: ${Colors.neutral700};
    justify-self: center;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      ${Typography.paragraph3}
    }
  `,
    logosContainer: css `
    display: grid;
    justify-content: center;
    grid-auto-flow: column;
    grid-gap: 40px;

    @media screen and (min-width: ${breakpoints.desktop}px) {
      grid-gap: 80px;
    }
  `,
    logoContainer: css `
    align-self: center;
    display: flex;
    justify-self: center;
  `,
    desktopLogoContainer: css `
    display: none;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      display: block;
    }
  `,
    mobileLogoContainer: css `
    display: block;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      display: none;
    }
  `,
    defaultLogo: (size) => [
        {
            '> svg': {
                height: 'inherit',
                width: 'inherit',
            },
        },
        size &&
            withModifier(sanitizeClassName(`${size}x${size}`), {
                height: size,
                width: size,
            }),
    ],
});
const DefaultLogo = (props) => {
    return (isolateComponent("span", { css: Styles.defaultLogo(props.size), className: "logobar-defaultLogo", dangerouslySetInnerHTML: { __html: props.svg } }));
};
const DefaultLogoIcons = {
    Asana: {
        mobile: AsanaIconMobile,
        desktop: AsanaIcon,
    },
    Dropbox: {
        mobile: DropboxIconMobile,
        desktop: DropboxIcon,
    },
    Meta: {
        mobile: MetaIconMobile,
        desktop: MetaIcon,
    },
    Shopify: {
        mobile: ShopifyIconMobile,
        desktop: ShopifyIcon,
    },
    Slack: {
        mobile: SlackIconMobile,
        desktop: SlackIcon,
    },
};
export const LogoBar = (_props) => {
    const { title, items, size, className } = _props;
    return (isolateComponent("div", { css: Styles.root, className: className },
        isolateComponent(HeadingLevel, null,
            isolateComponent(Heading, null,
                isolateComponent("div", { css: Styles.title, className: "logobar-title" }, title))),
        isolateComponent("ul", { css: Styles.logosContainer, className: "logobar-logosContainer" }, items && items.length > 0
            ? items.map(({ logoUrl, companyName }, i) => (isolateComponent("li", { css: Styles.logoContainer, key: i + logoUrl },
                isolateComponent(Img, { alt: companyName, borderRadius: 0, src: logoUrl, height: size, width: size }))))
            : DefaultCompanies.map((company) => (isolateComponent(Fragment, { key: company },
                isolateComponent("li", { css: [Styles.logoContainer, Styles.desktopLogoContainer] },
                    isolateComponent(DefaultLogo, Object.assign({}, DefaultLogoIcons[company].desktop, { size: size }))),
                isolateComponent("li", { css: [Styles.logoContainer, Styles.mobileLogoContainer] },
                    isolateComponent(DefaultLogo, Object.assign({}, DefaultLogoIcons[company].mobile, { size: size })))))))));
};
//# sourceMappingURL=LogoBar.js.map
// @zapier/design-system@6.14.1 (10126c41d)
